// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1198":"b05cbb47","6033":"f1a7a458","7886":"cdf21012","7992":"40caceae","9335":"a48ebd55"}[chunkId] + ".chunk.css";
};